import { Box, Button, Drawer, Stack, Tooltip } from '@mui/material'
import React, { Component } from 'react'
import '../pharmaReports.css';
import { Colors } from '../../../../Styles/Colors';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DataGrid } from '@mui/x-data-grid';
import { CommonCorporateAndInsuranceDetails, CommonGridToolBarWithFilterText } from '../../../../Components/Common Components/CommonComponents';
import { formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';
import { withTranslation } from 'react-i18next';
import PharmaFilter from '../PharmaFilter';
import { DateTime } from 'luxon';

class StockEditLog extends Component {

    constructor(props) {
        super(props)
        this.state = {
            stockCorrectionData: [],
            page: 0,
            pageSize: 10,
            rowCount: 0,
            filterDatas: {
                'fromDate': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                'toDate': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                "dateIndex": 1,
            },
            pageName: 'StockEditLog',
            filterOpen: false
        }
    }

    componentDidMount() {
        this.getStockCorrectionLogData()
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    renderFilter = (data) => {
        this.setState({
            filterDatas: data,
            filterOpen: false,
        }, () => { this.getStockCorrectionLogData() })
    }

    ClosePopUp() {
        this.setState({
            filterOpen: false,
        })
    }

    clearFilter = (data) => {
        this.setState({
            filterDatas: data
        })
    }

    gridToolBar = () => {
        var { t } = this.props
        let TextArray = [
            { label: "From Date", value: formatDate(this.state.filterDatas.fromDate) },
            { label: "To Date", value: formatDate(this.state.filterDatas.toDate) },
        ]
        return (
            <Box>
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} noExport={true} />
            </Box>

        )
    }

    getStockCorrectionLogData = () => {
        try {
            this.LoaderFunction(true)
            RestAPIService.getAll(Serviceurls.PHARMA_STOCK_EDIT_LOG + `?from_date=${this.state.filterDatas.fromDate}&to_date=${this.state.filterDatas.toDate}&po_number=&bill_no=&created_by=`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.setState({
                            stockCorrectionData: response.data.data
                        }, () => { this.LoaderFunction(false) })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.LoaderFunction(false)
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.LoaderFunction(false)
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    getStockCorrectionLogExcel = () => {
        try {
            this.setState({ disableBtn: true })
            RestAPIService.excelGet(Serviceurls.PHARMA_STOCK_EDIT_LOG + `?from_date=${this.state.filterDatas.fromDate}&to_date=${this.state.filterDatas.toDate}&po_number=&bill_no=&created_by=&export_type=excel`).
                then((response) => {
                    if (response.data) {
                        var pom = document.createElement('a');
                        var csvContent = response.data; //here we load our csv data 

                        let filename = response.headers["content-disposition"]?.split("filename=")[1]
                        // var blob = new Blob([csvContent], {type: 'data:application/vnd.ms-excel;base64'});

                        var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
                        var url = URL.createObjectURL(blob);
                        pom.href = url;
                        pom.setAttribute('download', filename ? filename : 'registry.xlsx');
                        pom.click();
                        this.setState({ disableBtn: false })
                    }
                }).catch((error) => {
                    if (error.response?.data?.message) {
                        this.errorMessage(error.response?.data?.message);
                    } else {
                        this.errorMessage(error.message);
                    }
                    this.setState({ disableBtn: false })
                })
        } catch (error) {
            this.errorMessage(error.message);
            this.setState({ disableBtn: false })
        }
    }

    StockCorrectionLogPrint = () => {
        try {
            this.setState({ disabled: true })
            RestAPIService.getAll(Serviceurls.PHARMA_INVENTORY_STOCK_CORRECTION_REPORT_GET + `?from_date=${this.state.filterDatas.fromDate}&to_date=${this.state.filterDatas.toDate}&po_number=&bill_no=&created_by=&export_type=pdf`).
                then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    this.setState({ disabled: false })
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                    this.setState({ disabled: false })
                })
        } catch (error) {
            this.errorMessage(error.message)
            this.setState({ disabled: false })
        }
    }

    render() {
        const { t } = this.props
        this.state.stockCorrectionData.forEach((element, index) => element.sno = index + 1)
        const columns = [
            { field: 'sno', headerName: 'S.No', flex: 0.05 },
            {
                field: 'created_date', headerName: "Edited Date & Time", flex: 0.111, headerAlign: 'center', align: 'center',
                renderCell: (params) => (<Box component={'div'}>{params?.row?.created_date ? params?.row?.created_date : '-'}</Box>)
            },
            {
                field: 'pi_date', headerName: "PI Date", flex: 0.111, headerAlign: 'center', align: 'center',
                renderCell: (params) => (<Box component={'div'}>{params?.row?.pi_date ? params?.row?.pi_date : '-'}</Box>)
            },
            {
                field: 'po_number', headerName: "PI Number", flex: 0.111, headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.po_number?.length > 18 ? <Tooltip placement='top' title={params?.row?.po_number} arrow><div>{params?.row?.po_number?.slice(0, 18) + '...'}</div></Tooltip> :
                        params?.row?.po_number ? params?.row?.po_number : '-'}
                </Box>)
            },
            {
                field: 'bill_date', headerName: "Bill Date", flex: 0.111, headerAlign: 'center', align: 'center',
                renderCell: (params) => (<Box component={'div'}>{params?.row?.bill_date ? params?.row?.bill_date : '-'}</Box>)
            },
            {
                field: 'bill_no', headerName: "Bill No", flex: 0.111, headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.bill_no?.length > 18 ? <Tooltip placement='top' title={params?.row?.bill_no} arrow><div>{params?.row?.bill_no?.slice(0, 18) + '...'}</div></Tooltip> :
                        params?.row?.bill_no ? params?.row?.bill_no : '-'}
                </Box>)
            },
            {
                field: 'created_by', headerName: "Edited By", flex: 0.111,
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.created_by?.length > 18 ? <Tooltip placement='top' title={params?.row?.created_by} arrow><div>{params?.row?.created_by?.slice(0, 18) + '...'}</div></Tooltip> :
                        params?.row?.created_by ? params?.row?.created_by : '-'}
                </Box>)
            },
            {
                field: 'no_of_update', headerName: `No.of.Updation`, flex: 0.111, type: "number", headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>{params.row?.no_of_update ? params.row?.no_of_update : '0'}</Box>)
            },
            {
                field: "action", flex: 0.07, headerName: t("Action"), headerAlign: "center", align: "center", sortable: false,
                renderCell: (params) => <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                    <Tooltip title={t("View")} placement="top" onClick={() => { this.props.history.push({ pathname: '/PharmacyReports/StockEditLogDetails', state: { EditedData: params?.row } }) }} arrow>
                        <Button emed_tid="vnd_view" className='eMed_usrconf_btn'>
                            <img src={ImagePaths.LabViewButton.default} alt="print" className='eMed_action_img' />
                        </Button>
                    </Tooltip>
                </Box>
            }
        ]
        return (
            <Box component={'div'} height={'80vh'} sx={{ backgroundColor: Colors.Background }}>
                <Box component={'div'} className='eMed_Pharma_rts_header' sx={{ height: "7vh" }}>
                    <Box component={'div'} flex={0.8} display={'flex'}>

                    </Box>
                    <Box flex={0.2} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} marginRight={'0.5vw'}>
                        {/* <Button className='eMed_Pharma_rts_btn' disabled={this.state.disabled}>
              <Box component={'img'} src={ImagePaths.LabPrintIcon.default} alt='print' height={'2.3vw'} width={'2.3vw'} onClick={() => this.StockCorrectionLogPrint()}/>
            </Button> */}
                        <Button emed_tid="rpt_stkCrt_export" className='eMed_Pharma_rts_btn' disabled={this.state.disableBtn || this.state.stockCorrectionData?.length === 0} onClick={() => this.getStockCorrectionLogExcel()}>
                            <Box component={'img'} src={(this.state.disableBtn || this.state.stockCorrectionData?.length === 0) ? ImagePaths.ExportIconOff.default : ImagePaths.ExportIcon.default} alt='export' height={'2.3vw'} width={'2.3vw'} />
                        </Button>
                        <Button emed_tid="rpt_stkCrt_flt" className='eMed_Pharma_rts_btn' onClick={() => this.setState({ filterOpen: true })}>
                            <Box component={'img'} src={ImagePaths.Filter.default} alt='filter' height={'2.3vw'} width={'2.3vw'} />
                        </Button>
                    </Box>
                </Box>
                <Box component={'div'} className='eMed_Pharma_rts_tbl_card' sx={{ height: "72vh" }}>
                    <DataGrid
                        className='eMed_Pharma_table'
                        rows={this.state.stockCorrectionData}
                        columns={columns}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        getRowId={(row) => row['sno']}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: this.gridToolBar,
                            NoRowsOverlay: () => (
                                <Stack className='eMed_conf_nodata'>
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        rowCount={this.state.stockCorrectionData?.length}
                        onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                        onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                        rowsPerPageOptions={[10, 20, 30]}
                        headerHeight={40}
                        disableSelectionOnClick
                        pagination
                        loading={this.state.isLoader}
                    />
                </Box>

                <Drawer
                    anchor={'right'}
                    open={this.state.filterOpen}
                    ModalProps={{ onBackdropClick: this.ClosePopUp.bind(this) }}
                >
                    <PharmaFilter filterDatas={this.state.filterDatas} closeFilter={this.ClosePopUp.bind(this)} filteredData={this.renderFilter.bind(this)} ClearData={this.clearFilter.bind(this)} />
                </Drawer>

                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
}

export default withTranslation()(StockEditLog)